import { useMemo } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useCrmFilterFields } from "@/react/hooks/useCrmFilters";
import { useIsActivityScoreEnabledOrUpgradable } from "@circle-react/hooks/useIsActivityScoreEnabled";
import { MemberFilters } from "@circle-react-shared/MemberFilters";
import { AllFiltersList } from "@circle-react-shared/MemberFilters/DynamicFilters/AllFiltersList";
import type { RenderFilter } from "@circle-react-shared/MemberFilters/types";
import { useMemberFilterDesign } from "../../shared/FilterV3/MemberFilterDesignContext";
import { useCrmTrueLocationFieldAndSearchEnabled } from "../../shared/MemberFilters/useCrmLocationEnabled";
import { memberDirectoryFilters } from "../memberDirectoryFilters";

const platformMemberFilters: RenderFilter[] = memberDirectoryFilters;

export const MembersFilters = ({
  className,
  filterRowClassName,
}: {
  className?: string;
  filterRowClassName?: string;
}) => {
  const isActivityScoreEnabledOrUpgradable =
    useIsActivityScoreEnabledOrUpgradable();

  const isCrmTrueLocationFieldAndSearchEnabled =
    useCrmTrueLocationFieldAndSearchEnabled();

  const crmFilters = useCrmFilterFields();

  const isMemberFilterDesignEnabled = useMemberFilterDesign();

  const defaultFilterItems = useMemo(() => {
    let items = ["name", "spaces", "tags", "events"];

    if (isActivityScoreEnabledOrUpgradable) {
      items.push("activity_score");
    }

    if (isMemberFilterDesignEnabled) {
      items = ["name", "headline", "bio", "location", "role"];
    }

    if (isCrmTrueLocationFieldAndSearchEnabled) {
      items.unshift("near_me");
      items.push("geo_location");
    }
    return items;
  }, [
    isActivityScoreEnabledOrUpgradable,
    isCrmTrueLocationFieldAndSearchEnabled,
    isMemberFilterDesignEnabled,
  ]);

  return (
    // Mobile version of filters are not ready, so hide for time being
    <div className={classNames("shadow-xs hidden md:flex", className)}>
      <MemberFilters
        className={filterRowClassName}
        platformFilters={[...platformMemberFilters, ...crmFilters]}
        defaultFilterNames={defaultFilterItems}
        persistentFilterNames={
          isCrmTrueLocationFieldAndSearchEnabled ? ["near_me"] : []
        }
      >
        <AllFiltersList />
      </MemberFilters>
    </div>
  );
};
